declare global {
  interface Window {
    grecaptcha?: {
      getResponse: (widgetId: number) => string;
      reset: (widgetId?: number) => void;
      render: (
        container: HTMLElement,
        parameters: {
          sitekey: string;
          callback?: (response: string) => void;
          'expired-callback'?: () => void;
        }
      ) => number;
    };
    onRecaptchaLoad?: () => void;
  }
}

export class RecaptchaService {
  private recaptchaIds: number[] = [];

  constructor(private captchaKey: string) {}

  public getCaptchaKey(): string {
    return this.captchaKey;
  }

  public getRecaptchaIds(): number[] {
    return this.recaptchaIds;
  }

  public addRecaptchaId(recaptchaId: number): void {
    if (!this.recaptchaIds.includes(recaptchaId)) {
      this.recaptchaIds.push(recaptchaId);
    }
  }

  /**
   * Deregister a widget whose container has been unmounted. Its response can no longer
   * be read, so leaving it registered would make validateAll() fail permanently.
   */
  public removeRecaptchaId(recaptchaId: number): void {
    this.recaptchaIds = this.recaptchaIds.filter((id) => id !== recaptchaId);
  }

  public getResponse(recaptchaId: number): string {
    if (!this.isLoaded(recaptchaId) || !window.grecaptcha) {
      return '';
    }

    return window.grecaptcha.getResponse(recaptchaId);
  }

  public validateResponse(recaptchaId: number): boolean {
    return this.getResponse(recaptchaId) !== '';
  }

  public validateAll(): boolean {
    let valid = true;

    this.recaptchaIds.forEach((id) => {
      if (!this.validateResponse(id)) {
        valid = false;
      }
    });

    return valid;
  }

  private isLoaded(recaptchaId: number): boolean {
    return this.recaptchaIds.includes(recaptchaId);
  }
}
